import { NoFoodImageResponse, NoFoodImageOptions } from 'types/food-image';

const FIXTURE: NoFoodImageResponse = {
  has_food_image: false,
  food_image_alt_choice: NoFoodImageOptions.NO_IMAGE,
  food_image_file: null,
};

export default FIXTURE;
